/**
 * A function which is executed if a product cannot be deleted.
 * It returns a string of unique product names
 *
 * @param errorResponse - IResponseError[]
 * @returns string
 */

import { IErrorObject, IResponseError } from 'src/types';

export const getDeleteErrorMessage = (errorResponse: IResponseError) => {
  if (!errorResponse.errors?.length) {
    return errorResponse.message;
  }

  const uniqueErrors = errorResponse.errors.filter(
    (error, index, arr) => index === arr.findIndex((item) => error.entity_id === item.entity_id),
  );

  const itemNames = uniqueErrors.map((error: IErrorObject) => error.message.split(/:\s/)[1]).join(', ');

  return `You cannot delete this item because it is part of the following: ${itemNames}. Please remove the item before trying again`;
};
